<template>
    <header class="position-fixed bg-light">
        <div class="container-fluid top-menu">
            <div class="container py-2">
                <div class="row">
                    <div class="col-xl-2 col-lg-4 col-sm-8 header-logo h-100 pt-0">
                        <router-link to="/" class="logo-text"><img src="@/assets/images/spectrum-logo-sm.jpg" alt="Company logo"></router-link>
                    </div>
                    <MobileMenu></MobileMenu>
                    <div class=" col-xl-9 navigation">
                        <ul class="header-nav-items menu">
                            <li>
                                <router-link class="header-nav-link" to="/">Home</router-link>
                            </li>
                            <li>
                              <router-link class="header-nav-link" to="/environmental-impact/">Environmental Impact</router-link>
                            </li>
                            <li>
                                <router-link class="header-nav-link" to="/about-us/">About us</router-link>
                            </li>
                            <li>
                                <router-link class="header-nav-link" to="/services/">Services</router-link>
                            </li>
                            <li>
                                <router-link class="header-nav-link" to="/testimonials/">Testimonials</router-link>
                            </li>
                            <li>
                                <router-link class="header-nav-link" to="/contact-us/">Contact us</router-link>
                            </li>
                            <li>
                                <a href="tel:+441953661644" class="header-nav-link"><img alt="Phone icon" src="@/assets/images/phone-purple.png" height="15" width="15"><strong> 01953 661644</strong></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import MobileMenu from '@/components/partials/MobileMenu'
export default {
  name: 'main-header',
  components: {
    MobileMenu
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue